import "./Home.module.css";
import KrbHeader from "@/reusable_sections/Header";
import GrowthEngineForYourCompany from "./sections/GrowthEngineForYourCompany";
import EviteMultasEErrosFiscais from "./sections/EviteMultasEErrosFiscais";
import SolucoesContabeisEspecializadas from "./sections/SolucoesContabeisEspecializadas";
import PathToOpenYourBusiness from "./sections/PathToOpenYourBusiness";
import AKrbAoSeuLado from "./sections/AKrbAoSeuLado";
import OQueDizemNossosClientes from "./sections/OQueDizemNossosClientes";
import InicieSuaTransformacao from "./sections/InicieSuaTransformacao";
import InformativeFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <KrbHeader />
      <GrowthEngineForYourCompany />
      <EviteMultasEErrosFiscais />
      <SolucoesContabeisEspecializadas />
      <PathToOpenYourBusiness />
      <AKrbAoSeuLado />
      <OQueDizemNossosClientes />
      <InicieSuaTransformacao />
      <InformativeFooter />
    </div>;
}